import { useCallback } from 'react';
import { toast } from 'react-toastify';

import { capitalize, copyToClipboard } from '@repo/utils';
import { Icon } from '../Icon/Icon';

import styles from './CopyField.module.css';

interface CopyFieldProps {
  value: string;
  name: string;
  onCopy?: (value: string, name: string) => void;
}

export const CopyField = ({ value, name, onCopy }: CopyFieldProps) => {
  const copyCodeToClipboard = useCallback(() => {
    if (!value) return;
    copyToClipboard(value);
    toast.success(`${capitalize(name)} copied to clipboard`);
    onCopy?.(value, name);
  }, [name, onCopy, value]);

  return (
    <div className={styles.copyField}>
      <span>{value}</span>
      <>
        <label htmlFor='copy-button' className='hidden'>
          Copy {name}
        </label>
        <button
          id='copy-button'
          className={styles.copyIcon}
          onClick={copyCodeToClipboard}
        >
          <Icon name='copy' size='m' />
        </button>
      </>
    </div>
  );
};

